import { render, staticRenderFns } from "./GPathCareerRoleDetail.vue?vue&type=template&id=10685ab0&scoped=true"
import script from "./GPathCareerRoleDetail.vue?vue&type=script&lang=js"
export * from "./GPathCareerRoleDetail.vue?vue&type=script&lang=js"
import style0 from "./GPathCareerRoleDetail.vue?vue&type=style&index=0&id=10685ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10685ab0",
  null
  
)

export default component.exports